import { render, staticRenderFns } from "./LivePlay.vue?vue&type=template&id=2f0afa81&"
import script from "./LivePlay.vue?vue&type=script&lang=js&"
export * from "./LivePlay.vue?vue&type=script&lang=js&"
import style0 from "./LivePlay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports